const claimDetails = () => import('@/views/main/cash-coupons/claimDetails/list.vue')
export default {
  path: '/main/coupons/claimDetails',
  name: 'claimDetails',
  component: claimDetails,
  children: []
}
